import axios from 'axios';
import { getAuth, resetAppState } from './AuthService';
import { SERVER_API_CONTEXT_PATH } from 'Constants';

const axiosInstance = axios.create({
  baseURL: SERVER_API_CONTEXT_PATH(process.env.REACT_APP_STAGE),
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use((config) => {
  if (getAuth()) {
    config.headers.Authorization = `Bearer ${getAuth().token}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && shouldRedirectToSignInPage(error?.config?.url))
      resetAppState();
    throw error;
  },
);

// check if url is not part of the list of non-redirecting request urls
function shouldRedirectToSignInPage(url) {
  return !['/api/auth/login', '/api/auth/changePassword'].includes(url);
}

export default axiosInstance;
